var styles = {"root":"ReferralFAQSection-module_root__vdpDd","faqSection":"ReferralFAQSection-module_faqSection__2Lmij","faqParagraph":"ReferralFAQSection-module_faqParagraph__1v7xN","faqParagraphDesktop":"ReferralFAQSection-module_faqParagraphDesktop__2dkCt","faqs":"ReferralFAQSection-module_faqs__3dufN","faqDescription":"ReferralFAQSection-module_faqDescription__1bokf"};

export { styles as default };
//# sourceMappingURL=ReferralFAQSection.module.css.js.map
